import { gql } from 'apollo-boost';

export const allQuicksightDashboardAccount = gql`
query {
  allQuicksightDashboardAccount {
    edges {
      node {
        id
        dbId
        accountId
        dashboardId
        awsId
        name
        information
      }
    }
  }
}
`;
